import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type IntervinientesStylesType = {
  wrapper: SxProps
  actions: SxProps
  switch: SxProps
  iconWarning: SxProps
  infoBar: SxProps
  requiredField: SxProps
}

export const intervinientesStyles: IntervinientesStylesType = {
  actions: {
    height: 50,
    backgroundColor: theme.colors.gray15,
    padding: theme.spacing(0, 1)
  },

  wrapper: {
    borderRadius: '8px',
    border: `1px solid ${theme.colors.main200}`,
    padding: theme.spacing(1.5)
  },

  switch: {
    marginTop: 2
  },

  iconWarning: {
    fontSize: '22px',
    marginRight: '4px'
  },

  infoBar: {
    marginBottom: theme.spacing(2)
  },

  requiredField: {
    display: 'block',
    color: theme.colors.red01,
    fontFamily: theme.corporate.primaryFont,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
    margin: '16px 0',

    '&:before': {
      position: 'relative',
      content: '"*"',
      fontFamily: theme.corporate.primaryFont,
      fontSize: '18px',
      color: theme.colors.red01
    }
  }
}
